import Service from '@/lib/App';

export const REST_COUNTRIES_KEY = 'REST';

export function buildSelectOptions(): { label: string; value: string }[] {
  return getValueLabelPairs(Service.cache.getCountriesMap());
}

function getValueLabelPairs(obj: {
  [key: string]: any;
}): { label: string; value: string; disabled?: boolean }[] {
  let valueLabelPairs = [];

  Object.entries(obj).forEach(([key, val]) => {
    if (typeof val === 'string')
      valueLabelPairs.push({
        label: val,
        value: key,
      });
    else if (key === REST_COUNTRIES_KEY) {
      valueLabelPairs.push({
        label: val['value'],
        options: getValueLabelPairs(val['children']),
      });
    }
  });

  return valueLabelPairs;
}

export function getKeyValuePairs(): { key: string; value: string }[] {
  return buildKeyValuePairs(Service.cache.getCountriesMap());
}

function buildKeyValuePairs(obj: {
  [key: string]: any;
}): { key: string; value: string }[] {
  let valueLabelPairs = [];

  Object.entries(obj).forEach(([key, val]) => {
    if (typeof val === 'string') valueLabelPairs.push({ key, value: val });
    else if (key === REST_COUNTRIES_KEY) {
      valueLabelPairs = valueLabelPairs.concat(
        buildKeyValuePairs(val['children']),
      );
    }
  });

  return valueLabelPairs;
}

export function getCountryNameByCountryCode(countryCode: string): string {
  if (!Service.cache.getCountriesMap()?.[countryCode])
    return Service.cache.getCountriesMap()?.[REST_COUNTRIES_KEY]?.children?.[
      countryCode
    ];

  return Service.cache.getCountriesMap()[countryCode];
}

function buildCountryCodeByName(
  obj: { [key: string]: any },
  name: string,
): string {
  let countryCode: string;

  Object.keys(obj).forEach((key) => {
    if (obj[key] === name) {
      countryCode = key;
      return false;
    }

    if (key === REST_COUNTRIES_KEY) {
      countryCode = buildCountryCodeByName(obj[key], name);
    }
  });

  return countryCode;
}

export function getCountryCodeByName(name: string): string {
  return buildCountryCodeByName(Service.cache.getCountriesMap(), name);
}

function parseObjToTree(obj) {
  const nodes = Object.keys(obj).map((key) => {
    const node = {
      title: obj?.[key]?.value || obj?.[key],
      value: key,
      key: key,
    };

    if (obj?.[key]?.children)
      node['children'] = parseObjToTree(obj[key].children);

    return node;
  });

  nodes.sort((a, b) => a.title.toString().localeCompare(b.title.toString()));
  nodes.forEach((node) => {
    if (node?.['children']) {
      node['children'] = node['children'].sort((a, b) =>
        a.title.toString().localeCompare(b.title.toString()),
      );
    }
  });

  return nodes;
}

export function getCountriesTree() {
  return parseObjToTree(Service.cache.getCountriesMap());
}
